module.exports = __webpack_public_path__ + "img/section_round_1.e8dc5312.svg";